import React from 'react';
import PropTypes from 'prop-types'

const IconCustomize2 = ({ color = '#585858', ...otherProps }) => (
  <svg width={45} height={32} viewBox="0 0 45 32" color={color} {...otherProps}>
    <g stroke={color} strokeWidth={2} fill="none" fillRule="evenodd">
      <path d="M29.573 24.436H15.61a2.918 2.918 0 01-2.918-2.918v-17.5a2.918 2.918 0 012.918-2.917h13.964a2.917 2.917 0 012.918 2.917v17.5a2.917 2.917 0 01-2.918 2.918z" />
      <path d="M12.691 4.267l-9.678 3.56a2.918 2.918 0 00-1.734 3.746l6.04 16.423a2.92 2.92 0 003.747 1.733l11.322-4.163 7.615 4.397a2.919 2.919 0 003.987-1.067l8.748-15.154a2.915 2.915 0 00-1.067-3.987l-9.18-5.301" />
    </g>
  </svg>
);

IconCustomize2.propTypes = {
  color: PropTypes.string
}

export default IconCustomize2;
